import { Component, inject } from '@angular/core';
import { Card } from 'primeng/card';
import {
  PRZEDZSIEBIORCY_MENU_ITEM,
  SWIADCZENIOBIORCY_MENU_ITEM,
} from './info-section-menu-items';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InfoDialog } from '../../../shared/components/info-dialog/info-dialog';
import { ButtonModule } from 'primeng/button';

const infoPopupHeaderTemplate = `
<div>Informacja</div>
<div class="services-info-description-header mt-2">
  <i class="pi pi-info-circle"></i>
  <span>Lista obsługiwanych wniosków w obszarze:</span>
</div>
`;
const infoPopupContentTemplate = `
<div class="services-info-dialog-content">
  <div class="services-info-description">
    <div #uslugiPoZalogowaniuObszar1 id="uslugiPoZalogowaniuObszar1">
      <span class="services-area">Aktywny Rodzic</span>
      <ol>
        <li>
          <span class="service-shortcut">AwP</span> - Wniosek o świadczenie
          Aktywni rodzice w pracy
        </li>
        <li>
          <span class="service-shortcut">AwD</span> - Wniosek o świadczenie
          Aktywni rodzice w domu
        </li>
        <li>
          <span class="service-shortcut">AwZ</span> - Wniosek o świadczenie
          Aktywni rodzice w żłobku
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar2 id="uslugiPoZalogowaniuObszar2">
      <span class="services-area">Świadczenia wychowawcze</span>
      <ol>
        <li>
          <span class="service-shortcut">SW-R</span> - Wniosek o Świadczenie
          Wychowawcze (Program „Rodzina 800+”)
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar3 id="uslugiPoZalogowaniuObszar3">
      <span class="services-area">Świadczenia Rodzinne</span>
      <ol>
        <li>
          <span class="service-shortcut">NSR-5</span> - Wniosek o ustalenie
          prawa do świadczenia pielęgnacyjnego na zasadach obowiązujących od 1
          stycznia 2024 r.
        </li>
        <li>
          <span class="service-shortcut">SR-1</span> - Wniosek o ustalenie prawa
          do zasiłku rodzinnego oraz dodatków do zasiłku rodzinnego
        </li>
        <li>
          <span class="service-shortcut">SR-2</span> - Wniosek o ustalenie prawa
          do jednorazowej zapomogi z tytułu urodzenia się dziecka
        </li>
        <li>
          <span class="service-shortcut">SR-3</span> - Wniosek o ustalenie prawa
          do zasiłku pielęgnacyjnego
        </li>
        <li>
          <span class="service-shortcut">SR-4</span> - Wniosek o ustalenie prawa
          do zasiłku opiekuńczego
        </li>
        <li>
          <span class="service-shortcut">SR-5</span> - Wniosek o ustalenie prawa
          do świadczenia pielęgnacyjnego na zasadach obowiązujących do 31
          grudnia 2023 r.
        </li>
        <li>
          <span class="service-shortcut">SR-7</span> - Wniosek o ustalenie prawa
          do świadczenia rodzicielskiego
        </li>
        <li>
          <span class="service-shortcut">SR-8</span> - Wniosek o ustalenie prawa
          do jednorazowego świadczenia z tytułu urodzenia się dziecka, u którego
          zdiagnozowano ciężkie i nieodwracalne upośledzenie albo nieuleczalną
          chorobę zagrażającą życiu, które powstały w prenatalnym okresie
          rozwoju dziecka lub w czasie porodu
        </li>
        <li>
          <span class="service-shortcut">ZS-1</span> - Wniosek o wydanie
          zaświadczenia o udzielonej pomocy
        </li>
        <li>
          <span class="service-shortcut">ZS-2</span> - Wniosek o umorzenie
          należności (w części lub w całości), rozłożenie na raty spłaty
          należności, odroczenie terminu płatności, zwolnienie lub zmniejszenie
          odpłatności (w związku z nienależnymi świadczeniami lub świadczeniami
          realizowanymi odpłatnie)
        </li>
        <li>
          <span class="service-shortcut">ZS-3</span> - Zgłoszenie
          nieprawidłowości o udzielonej pomocy
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar4 id="uslugiPoZalogowaniuObszar4">
      <span class="services-area">Dobry Start</span>
      <ol>
        <li>
          <span class="service-shortcut">DS-R</span> - Wniosek o Świadczenie
          Dobry start (wyprawka szkolna 300+)
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar5 id="uslugiPoZalogowaniuObszar5">
      <span class="services-area">Karta Dużej Rodziny</span>
      <ol>
        <li>
          <span class="service-shortcut">KDR</span> - Wniosek o ustalenie prawa
          do Ogólnopolskiej Karty Dużej Rodziny - system zniżek dla rodzin
          wielodzietnych
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar6 id="uslugiPoZalogowaniuObszar6">
      <span class="services-area">Fundusz Alimentacyjny</span>
      <ol>
        <li>
          <span class="service-shortcut">FA-1</span> - Wniosek o ustalenie prawa
          do świadczeń z funduszu alimentacyjnego
        </li>
        <li>
          <span class="service-shortcut">ZS-1</span> - Wniosek o wydanie
          zaświadczenia o udzielonej pomocy
        </li>
        <li>
          <span class="service-shortcut">ZS-2</span> - Wniosek o umorzenie
          należności (w części lub w całości), rozłożenie na raty spłaty
          należności, odroczenie terminu płatności, zwolnienie lub zmniejszenie
          odpłatności (w związku z nienależnymi świadczeniami lub świadczeniami
          realizowanymi odpłatnie)
        </li>
        <li>
          <span class="service-shortcut">ZS-3</span> - Zgłoszenie
          nieprawidłowości o udzielonej pomocy
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar7 id="uslugiPoZalogowaniuObszar7">
      <span class="services-area">Pomoc Społeczna</span>
      <ol>
        <li>
          <span class="service-shortcut">PS-1</span> - Wniosek o przyznanie
          pomocy społecznej
        </li>
        <li>
          <span class="service-shortcut">PS-2</span> - Powiadomienie o zmianie
          sytuacji życiowej
        </li>
        <li>
          <span class="service-shortcut">PS-3</span> - Informacja o potrzebie
          przyznania pomocy społecznej innej osobie/rodzinie
        </li>
<!--        <li>-->
<!--          <span class="service-shortcut">PS-U</span> - Pomoc jednorazowa dla-->
<!--          obywateli Ukrainy w wysokości 300 zł na osobę-->
<!--        </li>-->
        <li>
          <span class="service-shortcut">ZS-1</span> - Wniosek o wydanie
          zaświadczenia o udzielonej pomocy
        </li>
        <li>
          <span class="service-shortcut">ZS-2</span> - Wniosek o umorzenie
          należności (w części lub w całości), rozłożenie na raty spłaty
          należności, odroczenie terminu płatności, zwolnienie lub zmniejszenie
          odpłatności (w związku z nienależnymi świadczeniami lub świadczeniami
          realizowanymi odpłatnie)
        </li>
        <li>
          <span class="service-shortcut">ZS-3</span> - Zgłoszenie
          nieprawidłowości o udzielonej pomocy
        </li>
        <li>
          <span class="service-shortcut">ZS-4</span> - Wniosek o zmianę decyzji
          lub postanowienia
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar8 id="uslugiPoZalogowaniuObszar8">
      <span class="services-area">Świadczenia Wspierające</span>
      <ol>
        <li>
          <span class="service-shortcut">PPW</span> - Wniosek o wydanie decyzji
          ustalającej poziom potrzeby wsparcia
        </li>
        <li>
          <span class="service-shortcut">SWN</span> - Wniosek o świadczenie
          wspierające
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar9 id="uslugiPoZalogowaniuObszar9">
      <span class="services-area">Opieka nad dzieckiem do lat 3</span>
      <ol>
        <li>
          <span class="service-shortcut">RKZ-1</span> - Wpis do rejestru żłobków
        </li>
        <li>
          <span class="service-shortcut">RKZ-2</span> - Zmiana danych w
          rejestrze żłobków
        </li>
        <li>
          <span class="service-shortcut">RKZ-3</span> - Wykreślenie z rejestru
          żłobków
        </li>
        <li>
          <span class="service-shortcut">RKZ-4</span> - Sprawozdanie z
          działalności żłobków
        </li>
        <li>
          <span class="service-shortcut">RKZ-5</span> - Informacja o dzieciach
          uczęszczających do instytucji opieki
        </li>
        <li>
          <span class="service-shortcut">RKZ-6</span> - Wniosek dla podmiotów
          innych niż gmina (Aktywny Maluch 2022-2029)
        </li>
        <li>
          <span class="service-shortcut">RKZ-7</span> - Oświadczenie o przyjęciu
          dofinansowania (Aktywny Maluch 2022-2029)
        </li>
        <li>
          <span class="service-shortcut">RKZ-8</span> - Informacja o standardach
          opieki
        </li>
      </ol>
    </div>
    <div #uslugiPoZalogowaniuObszar10 id="uslugiPoZalogowaniuObszar10">
      <span class="services-area">Turnusy Rehabilitacyjne </span>
      <ol>
        <li>
          <span class="service-shortcut">ON-1</span> - Wpis do rejestru
          organizatorów turnusów rehabilitacyjnych
        </li>
        <li>
          <span class="service-shortcut">ON-2</span> - Wpis do rejestru ośrodków
          turnusów rehabilitacyjnych
        </li>
      </ol>
    </div>
  </div>
</div>
`;

@Component({
  selector: 'app-info-section',
  imports: [Card, ButtonModule],
  templateUrl: './info-section.html',
  styleUrl: './info-section.scss',
})
export class InfoSection {
  readonly #dialogService = inject(DialogService);

  protected readonly SWIADCZENIOBIORCY_MENU_ITEM = SWIADCZENIOBIORCY_MENU_ITEM;
  protected readonly PRZEDZSIEBIORCY_MENU_ITEM = PRZEDZSIEBIORCY_MENU_ITEM;

  protected onCardClick(itemId: string | undefined): void {
    if (itemId) this.#openInfoDialog(itemId);
  }

  #openInfoDialog(itemId: string): DynamicDialogRef {
    return this.#dialogService.open(InfoDialog, {
      closable: true,
      showHeader: true,
      header: 'Informacyjne okno dialogowe',
      closeOnEscape: true,
      modal: true,
      dismissableMask: true,
      styleClass: 'sr-only-header',
      width: '50vw',
      inputValues: {
        header: infoPopupHeaderTemplate,
        content: infoPopupContentTemplate,
        hideCancelButton: true,
        scrollTo: itemId,
      },
      breakpoints: {
        '960px': '90vw',
        '640px': '90vw',
      },
    })!;
  }
}
